import EditableList from "../components/EditableList";
import Saver from "../services/SaveService";
import ListModel from "../components/EditableListModel";

export default {
	components: {EditableList},
	created() {
		this.load();
	},
	data() {
		return {
			data: null,
			saver: new Saver(this),
		}
	},
	methods: {
		load() {
			this.backend.get().then(result => {
				this.data = new ListModel(result);
				this.saver.computeHashes(result);
			});
		},

		save() {
			this.saver.save(x => {
				this.backend.save(x).then(result => {
					if (result.status === "success") {
						this.saver.decSaving();
						if (result.message) {
							x._id = result.message;
						}
					} else {
						console.log(result.message);
						this.saver.error();
					}
				});
			}, x => {
				this.backend.delete(x).then(result => {
					if (result.status === "success") {
						this.saver.decSaving();
					} else {
						console.log(result.message);
						this.saver.error();
					}
				});
			});
		}
	}
}